import type * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 type-body-xxs-regular transition-colors focus-visible:outline-none focus-visible:border-2 focus-visible:border-[var(--focus-border)] focus-visible:ring-0",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground dark:text-black shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline:
          "border-[var(--color-border)] bg-transparent text-neutral-800 dark:text-neutral-200",
        muted:
          "rounded-sm border-[var(--color-border)] bg-neutral-50 px-1.5 text-neutral-800 dark:bg-neutral-900 dark:text-neutral-200",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
